import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { SIMPLE_FOOD_MOOD_FRAGMENT } from '../fragments'

const DELETE_FOOD_MOOD_MUTATION = gql`
  mutation deleteFoodMood($id: ID!) {
    deleteFoodMood(id: $id) {
      results {
        ...SimpleFoodMoodFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${SIMPLE_FOOD_MOOD_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DELETE_FOOD_MOOD_MUTATION
